import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import AboutSection from "../components/AboutSection";
import ServiceSection from "../components/ServiceSection";
import Faq from "../components/Faq";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import ItemsSection from "../components/ItemsSection";
import CategoriesSection from "../components/CategoriesSection";
import OHADACountries from "../components/OHADACountries";
import ReseauxSection from "../components/ReseauxSection";

import PartnersCarousel from "../components/PatnersCarousel";
import LogoBanner from "../components/LogoBanner";
import ArtCultureDivertissement from "./ArtCultureDivertissement";

const Home = () => {
  return (
    <>
      <div className="home-page">
        <span style={{ display: "block" }}>
          <Header />

          <Hero />
          <ItemsSection />
          <AboutSection />
          <CategoriesSection />
          <ServiceSection />
          <OHADACountries />
          <Faq />
          <PartnersCarousel />
          <ContactSection />
          <LogoBanner />
        </span>

        <Footer />
      </div>
    </>
  );
};

export default Home;
